/* 布局 */
//前台
import Layout from "@views/layout";

const graveareaRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "gravearea/list",
            name: "GRAVEAREA",
            meta: {
                title: "墓区管理",
                keepAlive: true
            },
            component: () => import("@views/business/gravearea/index.vue"),
        },
    ],
};

export default graveareaRouter;
